module.exports = __webpack_public_path__ + "static/media/ServiceBTL.4900fef7.jpg";